import { render, staticRenderFns } from "./content-card.vue?vue&type=template&id=fc4cd822&scoped=true&"
import script from "./content-card.vue?vue&type=script&lang=js&"
export * from "./content-card.vue?vue&type=script&lang=js&"
import style0 from "./content-card.vue?vue&type=style&index=0&id=fc4cd822&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4cd822",
  null
  
)

export default component.exports